import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import Modal from "react-modal";
import ModalVideo from "react-modal-video";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper.scss";
import image from "../../Assets/img/misc/Noblogedit.png";
import "./blog.css";
import Blogdata from "./blogdata";
import "./modal-video.scss";
import downloadfile from "./Resources/java.pdf";
let trigger;

function Blog(props) {
  // SwiperCore.use([FreeMode]);
  const [modalIsOpen4, setIsOpen4] = useState(null);
  const [cururl, setcururl] = useState("");

  const customStyles = {
    overlay: { zIndex: 10000, background: "rgba(0,0,0,.85)" },
  };

  const [isOpen5, setOpen5] = useState(false);
  function openModal4(index) {
    setIsOpen4(index);
  }

  function closeModal4() {
    setIsOpen4(null);
  }
  return (
    <div
      className={`col-lg-6  col-sm-12 col-xl-6 padding-0  job-type ${props.filter}`}
    >
      <div
        id={`vlcon${props.index}`}
        className={`vl ${props.isService ? "brad" : ""}`}
      >
        <div className="btnholder1">
          <button>
            <ExpandMoreIcon
              className="expicons"
              onClick={() => {
                let el = document.getElementById(`vlcon${props.index}`);
                el.scrollTop += 100;
              }}
            />
          </button>
          <button>
            <ExpandLessIcon
              className="expicons"
              onClick={() => {
                let el = document.getElementById(`vlcon${props.index}`);
                el.scrollTop -= 100;
              }}
            />
          </button>
        </div>
        <div className="topic">
          {props.topic}
          <br />
        </div>
        <div className="keywords">
          Keywords: <i>{props.keywords}</i>
        </div>
        <div className="span-in-div" style={{ textalign: "center" }}>
          <span className="applicationId">ID: {props.appID}</span>
          {"  "}
          <span className="deadline"> {props.date}</span>
        </div>
        <div style={{ lineHeight: "1", paddingBottom: "8px" }}>
          <div className="jobdescription">
            {props.projectdescription} Click{" "}
            <button
              className=" clickhere"
              onClick={() => {
                openModal4(props.index);
              }}
            >
              here
            </button>{" "}
            to read more.
          </div>
        </div>
      </div>

      <div className="videomodal">
        <Modal
          isOpen={modalIsOpen4 === props.index}
          onRequestClose={closeModal4}
          style={customStyles}
          contentLabel="Example Modal4"
          className={`Modal4${props.isService ? " Modal4leftpos" : ""}`}
          overlayClassName="Overlay4"
        >
          <ModalVideo
            channel="youtube"
            isOpen={isOpen5}
            videoId={cururl}
            onClose={() => setOpen5(false)}
            className="ModalVid"
          />
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-ride="false"
          >
            <div className="carousel-inner">
              {props.videos.map((e, index) => (
                <div
                  key={index}
                  className={`carousel-item${
                    index === 0 ? " active" : ""
                  } position-relative`}
                >
                  {e.picture && (
                    <img
                      className="d-block curimage"
                      src={e.picture}
                      alt="First slide"
                    />
                  )}

                  {e.videourl && (
                    <div style={{ height: !e.picture ? "200px" : "0px" }}>
                      <button
                        id="play-video"
                        className="video-play-button"
                        onClick={() => {
                          setcururl(e.videourl);
                          setOpen5(true);
                        }}
                      >
                        <span></span>
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <a
              className="carousel-control-prev"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>

          <br />
          <div id="snackbar" className="snackk">
            The background is simply the text shown.
          </div>

          <div className="projdesc">
            <div className="projtit">
              <b>{props.projecttitle}</b>
            </div>
            <div className="projkey">
              <span style={{ color: "black" }}>Keywords:</span>{" "}
              <b>
                <i>#Robotics , #CAD, #Simulation, #Controls</i>
              </b>
            </div>
            <b>Project Background</b>:{" "}
            <ReactMarkdown>{props.projectbackground}</ReactMarkdown>
            {props.pdf && (
              <p>
                Click
                <a href={downloadfile} target="_blank" rel="noreferrer">
                  <button className=" clickhere2">
                    <i
                      className="mx-1"
                      style={{ color: "#F19A1E", fontWeight: "bold" }}
                    >
                      here
                    </i>
                  </button>
                </a>
                to know more
              </p>
            )}
            <b>Project Brief:</b>{" "}
            <ReactMarkdown>{props.projectbrief}</ReactMarkdown>
          </div>
        </Modal>
      </div>
    </div>
  );
}

function Datedropdown(props) {
  return (
    <div className="dropdown-cus">
      <button
        className={`dropdown-toggle ${
          props.isService ? "btn832" : "btn btn-secondary"
        }`}
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Date
      </button>
      <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <button className="dropdown-item">Recent</button>
        <button className="dropdown-item">Last 1 week</button>
        <button className="dropdown-item">Last 1 month</button>
        <button className="dropdown-item">Last Quarter</button>
        <button className="dropdown-item">Last Year</button>
        <button className="dropdown-item">Max</button>
      </div>
    </div>
  );
}

function Blogs(props) {
  const [Catfilter, setCatfilter] = useState("All");
  const [Datefilter, setDatefilter] = useState(null);
  const [activefilter, setactivefilter] = useState(0);
  let portfolioref = useRef();
  let activeFilterIndex = 0;
  let dvar = "";
  if (props.isService) {
    dvar = "d-none";
  }
  trigger = () => {
    addButtonscroll();
  };
  async function addButtonscroll() {
    //used to scroll blog conatiner without button
    let l = document.getElementsByClassName("vl");

    Array.prototype.filter.call(l, function (el) {
      if (el.scrollHeight > el.offsetHeight) {
        el.firstChild.classList.remove("d-none");
      } else {
        el.firstChild.classList.add("d-none");
      }
    });
  }
  useEffect(() => {
    addButtonscroll();
  }, [Catfilter]);

  window.addEventListener("resize", () => {
    addButtonscroll();
  });

  const filters = [
    "All",
    "Accounting",
    "Audit & Assurance",
    // "Document & Report",
    "Compliance & Due Digilence",
    // "ESOP Policy",
    "GST",
    // "Income Tax",
    // "Labor Compliance",
    // "M&A Analysis",
    // "New Firm Set-up",
    // "Payroll",
    "Registrations",
  ];
  const clickHandler = (txt, index) => {
    setCatfilter(txt);
    setactivefilter(index);
    const filterButtons = document.querySelectorAll(".filter-button");
    for (let i = 0; i < filterButtons.length; i++) {
      document
        .querySelectorAll(`.filter-button-${i}`)[0]
        .classList.remove("active");
    }
    document
      .querySelectorAll(`.filter-button-${index}`)[0]
      .classList.add("active");
  };
  var noblogs = (
    <div className="d-flex flex-column my-3 align-items-center">
      <img className="w-50" src={image} alt="" />
      <h1 style={{ fontSize: "1.2rem" }} className="text-center my-3">
        We are working to expand our blog coverage. Please check our other blogs
        in the meantime
      </h1>
    </div>
  );

  var blogposts = Blogdata.map((blog, index) => {
    if (
      (Catfilter === "All" || Catfilter === blog.filter) &&
      Datefilter == null
    ) {
      return (
        <Blog
          key={index}
          index={index}
          filter={blog.filter}
          topic={blog.topic}
          keywords={blog.keywords}
          appID={blog.appID}
          date={blog.date}
          projectdescription={blog.projectdescription}
          videos={blog.videos}
          projectbackground={blog.projectbackground}
          projectbrief={blog.projectbrief}
          projecttitle={blog.projecttitle}
          isService={props.isService}
          pdf={blog.pdf}
        />
      );
    }
    return "";
  });
  return (
    <>
      <div className="formSection pb-1 py-md-2 " id="formSection">
        <div className="section-title container">
          <h2 className={dvar}>ACCOUNTING ONION</h2>
          <p className={dvar}>BLOGS</p>
          <div className="hiringtext">
            Illustrious consultants, expert witnesses, and practitioners,
            maintain a well-informed blog here. They bring a wealth of
            knowledge, and a touch of wit, to accounting, taxation and financial
            matters both arcane and practical. Providing invaluable insight into
            current trends and exposing financial reporting inconsistencies -
            committed to “peeling away…issues one layer at a time.
          </div>
        </div>
        <div className={`d-flex flex-row align-items-center filter-items-blog`}>
          {!props.isService && (
            <>
              <Swiper slidesPerView={"auto"}>
                {filters.map((txt, index) => (
                  <SwiperSlide key={index}>
                    <button
                      className={`filter-button mr-3 filter-button-${index} d-inline`}
                      onClick={() => {
                        clickHandler(txt, index);
                      }}
                    >
                      {txt}
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          )}

          {!props.isService && <Datedropdown />}
        </div>
        {/* to check whether if the blogposts is empty or not
        if empty we need to display no posts.
      */}
        {blogposts.every((elem) => elem === undefined) ? (
          noblogs
        ) : (
          <div className="long no-gutters ">
            <div className="grid no-gutters">
              <div
                ref={portfolioref}
                className="row portfolio-container no-gutters joinourteam"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                {blogposts}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function Section() {
  return (
    <section
      className="portfolio"
      id="Blogarea"
      // style={{ padding: "40px 0 100px 0px" }}
    >
      <div className="application-container " data-aos="fade-up">
        <Blogs />
      </div>
    </section>
  );
}

export { Blogs, Datedropdown, trigger };
export default Section;
